import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LoginForm } from './components/auth/LoginForm';
import { RegisterForm } from './components/auth/RegisterForm';
import { ForgotPasswordForm } from './components/auth/ForgotPasswordForm';
import { ChangePasswordForm } from './components/auth/ChangePasswordForm';
import { StravaConnect } from './components/auth/StravaConnect';
import { VerifyEmailForm } from './components/auth/VerifyEmailForm';
import { GroupList } from './components/groups/GroupList';
import { HomePage } from './pages/HomePage';
import { GroupDetail } from './components/groups/GroupDetail';
import { ContestDetail } from './components/contests/ContestDetail';
import { ChallengesPage } from './components/contests/ChallengesPage';
import { TeamDetail } from './components/teams/TeamDetail';
import { UserProfile } from './components/user/UserProfile';
import { ActivitiesList } from './components/activities/ActivitiesList';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { Layout } from './components/layout/Layout';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginForm />} />
        <Route path="/register" element={<RegisterForm />} />
        <Route path="/forgot-password" element={<ForgotPasswordForm />} />
        <Route path="/verify-email" element={<VerifyEmailForm />} />
        <Route path="/change-password" element={<ChangePasswordForm isMandatory={true} />} />
        <Route path="/connect-strava" element={<StravaConnect />} />
        <Route path="/" element={
          <ProtectedRoute>
            <Layout>
              <HomePage />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/groups" element={
          <ProtectedRoute>
            <Layout>
              <GroupList />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/groups/:id" element={
          <ProtectedRoute>
            <Layout>
              <GroupDetail />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/contests" element={
          <ProtectedRoute>
            <Layout>
              <ChallengesPage />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/contests/:id" element={
          <ProtectedRoute>
            <Layout>
              <ContestDetail />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/teams/:id" element={
          <ProtectedRoute>
            <Layout>
              <TeamDetail />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/activities" element={
          <ProtectedRoute>
            <Layout>
              <ActivitiesList />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/profile" element={
          <ProtectedRoute>
            <Layout>
              <UserProfile />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/profile/change-password" element={
          <ProtectedRoute>
            <Layout>
              <ChangePasswordForm />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/connect-strava" element={
          <ProtectedRoute>
            <Layout>
              <StravaConnect />
            </Layout>
          </ProtectedRoute>
        } />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
